import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const authMethods = mapActions('auth', ['logIn','logInMitta','logOut','logOutMitta', 'register', 'resetPassword', 'saveContact', 'updatePassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const requestsMethods = mapActions('requests', ['getAllRequests', 'getOneRequest', 'getProductos','getMotivos','getSubMotivos', 'createCaso'])

export const parametersMethods = mapActions('parameters', ['getAllParameters'])

export const notesMethods = mapActions('notes', ['getAllNotes','addNote']);

export const filesMethods = mapActions('files', ['getAllFiles','addFile', 'downloadFile']);

export const empresasMethods = mapActions('rutEmpresa', ['getEmpresas', 'selectAcount']);

export const docsMethods = mapActions('docs', ['addBoleta']);

export const hideValueMethod = mapActions('hideValue', ['updateId', 'updateFilter', 'updateGastos']);
